import React from 'react';
import { useSelector } from 'react-redux';
import ChildrenSettingComponent from '../components/children_setting';


const ChildrenSettingPageContainer  = () => {

  const { userInfo ,type } = useSelector((state) => state.authReducers);

  return <ChildrenSettingComponent
      userInfo={userInfo}
  />;
};

export default ChildrenSettingPageContainer ;
